import { Fragment, useState } from "react";
import { connect } from "react-redux";
import { useTranslation } from "react-i18next";
import { Modal, ModalBody, ModalFooter } from "reactstrap";
import SelectBox from "components/elements/selectBox";

function ModalUpload({ onSubmit, categories }) {
    const [categoriesProduct, setCategoriesProduct] = useState('');
    const [isOpen, setIsOpen] = useState(false);
    const { t } = useTranslation();

    const onClose = () => {
        setIsOpen(false);
    };

    const handleSubmit = () => {
        onSubmit(categoriesProduct);
        onClose();
    };

    return (
        <Fragment>
            <button
                className="btn btn-sm btn-info me-2 mb-2"
                data-bs-toggle="modal"
                data-bs-target="#kt_modal_create_app"
                id="kt_toolbar_primary_button"
                onClick={() => setIsOpen(true)}
            >
                <i className="ki-outline ki-cloud-download"></i>
                {t("Move Niche")}
            </button>
            <Modal
                centered={true}
                size="lg"
                toggle={() => {
                    onClose();
                }}
                isOpen={isOpen}
            >
                <div className="modal-header">
                    <div className="btn btn-sm btn-icon btn-active-color-primary" data-bs-dismiss="modal">
                        <i
                            className="ki-outline ki-cross fs-1"
                            onClick={() => {
                                onClose();
                            }}
                        ></i>
                    </div>
                </div>
                <ModalBody>
                    <div className="form-group">
                        <label className="d-flex align-items-center fs-6 fw-semibold mb-2">
                            <span className="required">{t("Move to")}</span>
                        </label>
                        <div>
                            <SelectBox
                                options={categories}
                                name="filter_categories"
                                value={categoriesProduct || ""}
                                onChange={(data) => {
                                    setCategoriesProduct(data.value || "");
                                }}
                            />
                        </div>
                    </div>
                </ModalBody>
                <ModalFooter>
                    <button
                        type="reset"
                        id="kt_modal_users_search_reset"
                        data-bs-dismiss="modal"
                        className="btn btn-active-light me-3"
                        onClick={() => {
                            onClose();
                        }}
                    >
                        {t("Cancel")}
                    </button>
                    <button
                        onClick={handleSubmit}
                        type="submit"
                        id="kt_modal_users_search_submit"
                        className="btn btn-primary"
                    >
                        {t("Save")}
                    </button>
                </ModalFooter>
            </Modal>
        </Fragment>
    );
}

const mapStateToProps = (state) => ({});
const mapDispatchToProps = { };

export default connect(mapStateToProps, mapDispatchToProps)(ModalUpload);